import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckboxModule } from "primeng/checkbox";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ManageProfileRoutingModule } from './manage-profile-routing.module';
import { ManageProfileFormComponent } from './manage-profile-form/manage-profile-form.component';
import { MatDialogModule } from '@angular/material/dialog';
import { UpdateContactComponent } from './update-contact/update-contact.component';
import { ToggleMaskDirective } from '@app/shared/directives/toggle-mask.directive';
import { SsnMaskDirective } from '@app/shared/directives/ssn-mask.directive';
@NgModule({
  declarations: [
    ManageProfileFormComponent,
    UpdateContactComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ManageProfileRoutingModule,
    CheckboxModule,
    MatDialogModule
    ,ToggleMaskDirective,
    SsnMaskDirective
  ]
})
export class ManageProfileModule { }
